import * as types from '../constants/actionTypes';
import update from "immutability-helper";

export default function assignment(state = {

    id : "",
    name: "",
    description: "",
    use_date_control : false,
    due_date: undefined,
    access_open_date: undefined,
    submission_open_date: undefined,
    submission_close_date: undefined,
    access_close_date: undefined,
    type: "",
    submission_attempts_max: 0,
    group_submission: false,
    students_per_group_max: "",
    students_per_group_min: "",
    allow_not_done: false,
    allow_arbitrary_uploads: false,
    script_enabled: false,
    submission_enabled: false,
    access_enabled: false,
    assignment_filenames: [],
    dropbox: "",
    dropbox_details: [],
    submissions: [],
    updated: null

}, action) {
    switch (action.type) {
        case types.ASSIGNMENT__CLEAR__REQUESTED: {
            return {};
        }

        case types.DROPBOX__ASSIGNMENT__REQUESTED__SUCCEEDED: {
            return {
                ...action.payload.assignment,
            };
        }

        case types.ASSIGNMENT__CREATE__REQUESTED__SUCCEEDED: {

            return {
                ...action.payload.assignment,
            };

        }

        case types.ASSIGNMENT__UPDATE__REQUESTED__SUCCEEDED: {

            return {
                ...action.payload.assignment,
            };

        }

        case types.ASSIGNMENT__CREATE__REQUESTED: {

            return state;

        }

        case types.ASSIGNMENT__FILE__UPLOAD__REQUEST__SUCCEEDED: {
            const files = state.assignment_files;
            let file_index = null;
            for(let i in files){
                if (files[i].name === action['file'].name){
                    file_index = i;
                    break;
                }
            }
            let newState = update(state, {
                assignment_files: {
                    [file_index]: {
                        size: {$set: action.file.size},
                        progress: { $set: 100},
                        updated : { $set: action.file.updated},
                        id : { $set: action.file.id}
                    }
                }
            });

            return {
                ...state,
                assignment_files: newState.assignment_files
            };
        }

        case types.ASSIGNMENT__FILE__UPLOAD__REQUEST__FAILED: {
            const files = state.assignment_files;
            let file_index = null;
            for(let i in files){
                if (files[i].name === action.files['file'].name) {
                    file_index = i;
                    break;
                }
            }

            let newState = update(state, {
                assignment_files: {
                    [file_index]: {
                        progress: { $set: -1}
                    }
                }
            });

            return {
                ...state,
                assignment_files: newState.assignment_files
            };
        }

        case types.ASSIGNMENT__FILE__UPLOAD__BAD__REQUEST: {
            const files = state.assignment_files;
            let file_index = null;
            for(let i in files){
                if (files[i].name === action.files['file'].name) {
                    file_index = i;
                    break;
                }
            }

            let newState = update(state, {
                assignment_files: {
                    [file_index]: {
                        progress: { $set: -1}
                    }
                }
            });

            return {
                ...state,
                assignment_files: newState.assignment_files
            };
        }

        case types.ASSIGNMENT__FILE__UPLOAD__REQUESTED: {
            const files = state.assignment_files;
            let file_index = null;
            for(let i in files){
                if (files[i].name === action.payload['file'].name){
                    file_index = i;
                    break;
                }
            }

            if (file_index !== null) {

                let newState = update(state, {
                    assignment_files: {
                        [file_index]: {
                            progress: {$set: 0}
                        }
                    }
                });

                return {
                    ...state,
                    assignment_files: newState.assignment_files,
                };
            }else {

                const newFile = {
                    'name': action.payload.file.name,
                    'size': action.payload.file.size,
                    'progress': 0
                };

                return {
                    ...state,
                    assignment_files: [...state.assignment_files, newFile],
                };

            }
        }

        case types.ASSIGNMENT__FILE__DELETE__REQUEST__SUCCEEDED: {
            let assignment_files = state.assignment_files.filter((assignment) => {
                return action.file.name !== assignment.name;
            });

            return {
                ...state,
                assignment_files: assignment_files
            };
        }

        default:
            return state;
    }

}



/** WEBPACK FOOTER **
 ** ./src/reducers/assignmentReducer.js
 **/